import BaseInfo from '@/model/modules/BaseInfo'
import FromUserInfo from '@/model/modules/FromUserInfo'
import CourierInfo from '@/model/modules/CourierInfo'

export default class OrderInfo extends BaseInfo {
  batchNumber: string = ''
  cargoType: number = 0
  // 订单号
  orderNo: string = ''
  // 收件人
  receiveName: string = ''
  // 收件公司
  receiveCompany: string = ''
  // 收件地址
  receiveAdd1: string = ''
  // 收件地址2
  receiveAdd2: string = ''
  // 收件城市
  receiveCity: string = ''
  // 收件省
  receiveState: string = ''
  // 收件邮编
  receivePostcode: string = ''
  // 收件人电话
  receiveTel: string = ''
  // 收件人国家
  receiveCountry: string = ''
  // 总金额
  totalPrice: number = 0
  // 备注
  remark: string = ''
  // 发送日期
  shipDate: Date = new Date()
  // 渠道
  channel: number = 0
  // 状态
  status: number = 0
  user: number = 0
  // 商品单重
  productWeight: number = 0
  // 长
  length: number = 0
  // 宽
  width: number = 0
  // 高
  height: number = 0
  sku: string = ''
  // 中文名
  chineseName: string = ''
  // 英文名
  englishName: string = ''
  // 金额
  price: number = 0
  // 申报数量
  num: number = 0
  // 材质
  material: string = ''
  // 用途
  uses: string = ''
  // 海关编号
  hscode: string = ''
  // 创建日期
  createAt: number = 0
  fromUserDto: FromUserInfo = new FromUserInfo()
  fromUserId: number = 0
  courierDto: CourierInfo = new CourierInfo()
  // 跟踪号
  mainOrderNo: string = ''
  // 整个数据数量
  totalSize: number = 0
  // 调用物流API时候返回的错误信息，或者运费试算的时候返回的报错
  errorMessage: string = ''
  // 是否已经计算运费结束
  isFinsh: boolean = false
  // 计算运费的时候的错误信息
  errorPostcodeMessage: string = ''
}
